import { CLOSE_WEIGHT_DISPUTE_SUCCESS, CLOSE_WEIGHT_DISPUTE_REQUEST, CLOSE_WEIGHT_DISPUTE_FAILURE, CLOSE_WEIGHT_DISPUTE_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const closeWeightDisputeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLOSE_WEIGHT_DISPUTE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case CLOSE_WEIGHT_DISPUTE_REQUEST:
            return Object.assign({}, state);
        case CLOSE_WEIGHT_DISPUTE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case CLOSE_WEIGHT_DISPUTE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default closeWeightDisputeReducer;
